<template>
  <div class="wait-detail-list">
    <div class="thead f-12 c-9">
      <div class="col-1 text-head">商品</div>
      <div class="col-2 th2 text-head">商品属性</div>
      <div class="col-3 text-head">结算单价</div>
      <div class="col-4 text-head">结算数量</div>
      <div class="col-5 text-head">结算重量</div>
      <div class="col-6 text-head">结算金额</div>
    </div>
    <div class="table" v-for="(order, oIndex) in data" :key="oIndex">
      <div class="tbody lh-20">
        <div class="m-t10 m-l10 f-12 c-6">
          <span
            >结算单号：<span class="link" @click="handleLink(order.settleOrderId)">{{
              order.settleOrderNo
            }}</span></span
          >
          <span class="m-l20">结算状态：{{ order.status | convertStatus }}</span>
          <span class="m-l20">结算单创建时间：{{ order.gmtCreated | parseTime }}</span>
          <span class="m-l20">结算金额：{{ order.$totalAmount | currencyFormat }}</span>
        </div>
        <div class="row" v-for="(item, index) in order.list" :key="index">
          <div class="col-1 p-10 flex-h-ac">
            <div>
              <p class="f-14 c-3">{{ item.itemTitle }}</p>
              <p class="f-12 c-9 m-t10">商品编号：{{ item.itemSkuId || item.itemId }}</p>
              <p v-if="item.supplierName" class="f-12 c-9">{{ item.supplierName }}</p>
            </div>
          </div>
          <div class="col-2 text-attr">
            <p v-if="item.measureType">计量方式：{{ item.measureType }}</p>
            <p v-if="item.chargeUnit">计价单位：{{ item.chargeUnit }}</p>
            <p v-if="item.qualityGrade">质量等级：{{ item.qualityGrade }}</p>
            <p v-if="item.tolerance">公差：{{ item.tolerance }}</p>
            <p v-if="item.bundleNo">捆包号：{{ item.bundleNo }}</p>
            <p v-if="item.perItemWeight">单件重：{{ item | formatPerItemWeight }}</p>
            <p v-if="item.warehouseName">仓库名：{{ item.warehouseName }}</p>
          </div>
          <div class="col-3">{{ item.settlePerAmount | currencyFormat }}/{{ item.chargeUnit }}</div>
          <div class="col-4">{{ item.settleQuantity }}件</div>
          <div class="col-5">{{ item.settleWeight | formatWeight }}吨</div>
          <div class="col-6">{{ item.settleAmount | currencyFormat }}</div>
        </div>
      </div>
      <div class="tfoot">
        <div>
          订单结算小计： <span class="text-blod">{{ order.$totalQuantity }}</span
          >件， <span class="text-blod">{{ order.$totalWeight | formatWeight }}</span
          >吨
          <span class="m-l10"
            ><span class="text-blod">{{ order.$totalAmount | currencyFormat }}</span></span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NP from 'number-precision'

export default {
  name: 'WaitDetailList',
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  filters: {
    convertStatus(status) {
      let text = ''
      if (status === 1) {
        text = '待结算确认'
      } else if (status === 2 || status === 3) {
        text = '已结算确认'
      }
      return text
    },
    formatPerItemWeight(data) {
      if (data.chargeUnit === '千克') {
        return `${NP.divide(data.perItemWeight, 10)}千克`
      } else {
        return `${NP.divide(data.perItemWeight, 10000)}吨`
      }
    }
  },
  watch: {
    data: {
      handler: 'calculateTotal',
      immediate: true
    }
  },
  methods: {
    calculateTotal() {
      //计算结算小计
      this.data.forEach(val => {
        let totalQuantity = 0
        let totalWeight = 0
        let totalAmount = 0
        val.list.forEach(ele => {
          totalQuantity = NP.plus(ele.settleQuantity, totalQuantity)
          totalWeight = NP.plus(ele.settleWeight, totalWeight)
          totalAmount = NP.plus(ele.settleAmount, totalAmount)
        })
        val.$totalQuantity = totalQuantity
        val.$totalWeight = totalWeight
        val.$totalAmount = totalAmount
      })
    },
    handleLink(settleOrderNo) {
      this.$router.push({ name: 'SettlementDetail', params: { id: settleOrderNo } })
    }
  }
}
</script>

<style lang="less" scoped>
.wait-detail-list {
  margin-top: 20px;

  .link {
    border-bottom: 1px solid #666;
    cursor: pointer;
  }
  .table {
    border: 1px solid #f0f0f0;
    margin-top: 20px;
  }
  .thead {
    height: 41px;
    line-height: 41px;
    box-sizing: border-box;
    background: #f8f8f8;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #f0f0f0;
    border: 1px solid #f0f0f0;
  }
  .tbody {
    box-sizing: border-box;
  }
  .row {
    display: flex;
    border-bottom: 1px solid #f0f0f0;
  }
  .base-col {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 10px;
    font-size: 14px;
    color: #666;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-all;
  }
  .col-1 {
    .base-col;
    width: 18%;
  }
  .col-2 {
    .base-col;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 18%;
  }
  .th2 {
    align-items: center;
  }
  .col-3 {
    .base-col;
    width: 16%;
  }
  .col-4 {
    .base-col;
    width: 16%;
  }
  .col-5 {
    .base-col;
    width: 16%;
  }
  .col-6 {
    .base-col;
    width: 16%;
  }
  .tfoot {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 50px;
    padding: 0 20px;
    background: #f8f8f8;
    font-size: 14px;
    font-weight: 500;
    color: #333333;
  }
  .text-blod {
    font-size: 20px;
    color: #f0242e;
  }
  .text-head {
    font-size: 12px;
    color: #999;
  }
  .text-attr {
    font-size: 12px;
    color: #666;
  }
}
</style>
